import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import { GridTableContext } from '../../contexts';
import { classes, Search } from './search-filter.style';

export function SearchFilter({
  onEnter,
  defaultValue
}: {
  onEnter?: () => void;
  defaultValue?: string;
}): JSX.Element {
  const [currentValue, setCurrentValue] = React.useState<string>('');
  const {
    instance: {
      gotoPage,
      setGlobalFilter,
      state: { globalFilter }
    }
  } = React.useContext(GridTableContext);

  React.useEffect(() => {
    const newValue = globalFilter ?? '';
    if (currentValue != newValue) {
      setCurrentValue(newValue);
    }
  }, [globalFilter]);

  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      onSearch();
    }, 500);
    return (): void => clearTimeout(timeoutId);
  }, [currentValue]);

  React.useEffect(() => {
    if (defaultValue && defaultValue !== '') {
      setCurrentValue(defaultValue);
    }
  }, [defaultValue]);

  const onSearch = (): void => {
    gotoPage(0);
    if (onEnter) {
      onEnter();
    }
    setGlobalFilter(currentValue !== '' ? currentValue : undefined);
  };

  return (
    <Search>
      <div className={classes.searchIcon}>
        <SearchIcon />
      </div>
      <TextField
        placeholder='Search'
        onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
          setCurrentValue(event.target.value);
        }}
        value={currentValue}
        onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>): void => {
          if (event.key == 'Enter') {
            event.preventDefault();
            onSearch();
          }
        }}
        variant='standard'
        InputProps={{
          className: classes.input
        }}
      />
    </Search>
  );
}
